const initialState = {
  app: null,
};

const signin = (state: any = initialState, action: any) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default signin;



// WEBPACK FOOTER //
// ./src/store/reducers/App.tsx